import { render } from "./icon-back.vue?vue&type=template&id=321407c3"
import script from "./icon-back.vue?vue&type=script&lang=js"
export * from "./icon-back.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__